












































































































































































































































import Vue from 'vue'
import axios from 'axios'
import axiosJsonpAdapter from 'axios-jsonp'
import SubmitFlow from '../organisms/SubmitFlow.vue'
import WebSubmitNote from '../organisms/WebSubmitNote.vue'
import ExmasForTensakuVisiter from '../../utils/ExmasForTensakuVisiter'
import { examInfo } from '../../utils/ExmasForTensakuVisiter/type'

export type DataType = {
  examInfo?: examInfo,
  childName: string[],
  telItem: string[],
  email: string,
  confirmEmail: string,
  isKaiin: boolean,
  errors: any, // {変数名: エラーメッセージ}
  isLoading: boolean,
  zipCode: string[],
  prefecture: null | string,
  municipalities: string,
  address: string,
  prefectures: (null | string)[]
}

export default Vue.extend({
  components: {
    SubmitFlow,
    WebSubmitNote,
  },
  data(): DataType {
    return {
      examInfo: undefined,
      childName: ['', ''],
      telItem: ['', '', ''],
      email: '',
      confirmEmail: '',
      isKaiin: false,
      errors: {},
      isLoading: false,
      zipCode: ['', ''],
      prefecture: null,
      municipalities: '',
      address: '',
      prefectures: [
        null,
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県',
      ],
    }
  },
  created() {
    this.$store.commit('SET_EXAM_INFO', { examInfo: null })
    const examKey = this.$route.params['exam_id']
    if (Object.keys(ExmasForTensakuVisiter).includes(examKey)) {
      this.examInfo = ExmasForTensakuVisiter[examKey]
    }
  },
  computed: {
    questionPageUrl(): string {
      return `/tensaku_visiter/faq/${this.examInfo?.examGroupKey}`
    },
    hasError(): boolean {
      return Object.keys(this.errors).length > 0
    },
    telNo(): string {
      return this.telItem.join('-')
    },
    isOverPeriod(): boolean {
      if (!this.examInfo?.registEndTo) {
        return false
      }
      return new Date(this.examInfo?.registEndTo) < new Date()
    }
  },
  methods: {
    validate(name: string, errorMessage: string, errorConditionFunc: () => boolean) {
      if (this.errors[name]) {
        return
      }
      if (errorConditionFunc()) {
        this.errors[name] = errorMessage
      }
    },
    validateAll(): boolean {
      this.errors = {}
      this.validate("childName1", '入力してください。', () => !this.childName[0])
      this.validate("childName2", '入力してください。', () => !this.childName[1])
      this.validate("telItem", '入力してください。', () => this.telItem.some(x => !x))
      this.validate("telItem", '半角数字で入力してください。', () => /[^0-9]/.test(this.telItem.join('')))
      this.validate("email", '入力してください。', () => !this.email)
      this.validate("confirmEmail", '入力してください。', () => !this.confirmEmail)
      this.validate("confirmEmail", 'メールアドレスと確認用メールアドレスが一致しません。', () => this.email !== this.confirmEmail)
      if (this.examInfo?.requireInputAddress) this.validate("zipCode", '入力して下さい', () => !this.zipCode[0] || !this.zipCode[1])
      if (this.examInfo?.requireInputAddress) this.validate("prefecture", '入力して下さい', () => !this.prefecture)
      if (this.examInfo?.requireInputAddress) this.validate("municipalities", '入力して下さい', () => !this.municipalities)
      if (this.examInfo?.requireInputAddress) this.validate("address", '入力して下さい', () => !this.address)
      return !this.hasError
    },
    async regist() {
      try {
        this.isLoading = true
        if (this.validateAll()) {
          const res = await axios.post('/api/v1/preuser_regist', {
            exam_id: this.$route.params['exam_id'],
            email: this.email,
            child_name: this.childName.join('　'),
            phone: this.telNo,
            zip_code: this.zipCode.join('-'),
            prefecture: this.prefecture,
            municipalities: this.municipalities,
            address: this.address,
            isKaiin: this.examInfo!.showIsKaiin ? this.isKaiin : null
          })
          if (res.data.exist == "user") {
            this.errors = {}
            this.validate("childName", res.data.message, () => true)
            window.scrollTo({ top: 500, behavior: "smooth" })
          } else {
            this.$store.commit('SET_EXAM_INFO', { examInfo: this.examInfo })
            this.$router.push('/tensaku_visiter/regist_result')
          }
        } else {
          window.scrollTo({ top: 500, behavior: "smooth" })
        }
      } finally {
        this.isLoading = false
      }
    },
    async postalSearch() {
      if (this.zipCode.join('-') === '-') {
        this.$set(this.errors, 'zipCode', '郵便番号を入力して下さい')
        return
      }
      const res = await axios.get(process.env.VUE_APP_ZIPCODE_API_URL as string, {
        dataType: 'application/json',
        adapter: axiosJsonpAdapter,
        params: {
          zipcode: this.zipCode.join('-')
        }
      })
      if (!res) {
        this.errors['zipCode'] = ''
        this.$set(this.errors, 'zipCode', '郵便番号が正しくありません。')
      } else if (!res.data.results){
        this.errors['zipCode'] = ''
        this.$set(this.errors, 'zipCode', '郵便番号が正しくありません。')
      } else {
        this.errors['zipCode'] = ''
        const data = res.data
        const result = data.results[0]
        this.prefecture = result.address1
        this.municipalities = result.address2 + result.address3
      }
    },
  }
})
